import type { Member } from '@tribeplatform/gql-client/types'

import type { StaticField, View } from '../../Views/types'
import { MembersCarousel } from './MembersCarousel'
import { MembersGallery } from './MembersGallery'
import { MembersList } from './MembersList'
import { MembersMagazine } from './MembersMagazine'

interface Props {
  style: View['style']
  members: Member[]
  fields: StaticField[]
  gallerySize?: View['gallerySize']
  showDivider?: View['showDivider']
  activeFieldId?: string
  showMoreButton: JSX.Element
}
export const GenericMembersList = ({
  style,
  members,
  fields,
  gallerySize,
  showDivider,
  activeFieldId,
  showMoreButton,
}: Props) => {
  switch (style) {
    case 'gallery':
      return (
        <MembersGallery
          members={members}
          fields={fields}
          gallerySize={gallerySize}
          activeFieldId={activeFieldId}
          showMoreButton={showMoreButton}
        />
      )
    case 'list':
      return (
        <MembersList
          members={members}
          fields={fields}
          showDivider={showDivider}
          activeFieldId={activeFieldId}
          showMoreButton={showMoreButton}
        />
      )
    case 'carousel':
      return (
        <MembersCarousel
          members={members}
          fields={fields}
          gallerySize={gallerySize}
          activeFieldId={activeFieldId}
          showMoreButton={showMoreButton}
        />
      )
    case 'magazine':
      return (
        <MembersMagazine
          members={members}
          fields={fields}
          activeFieldId={activeFieldId}
          showMoreButton={showMoreButton}
        />
      )
    default:
      return null
  }
}
